// src/pages/HomePage.js
import React from 'react';
import PaperViewer from '../components/Public/PaperViewer';
import YouTubeEmbed from './YouTubeEmbed';


const HomePage = () => {
  return (
    <div className="home-page">
      <PaperViewer />
      <YouTubeEmbed videoId="aAzq2pO7cQk?si=RAZt-z9D9m94lCaj" />

    </div>
  );
};

export default HomePage;